import { Box } from '@mui/material';
import {
	FacebookShareButton,
	LinkedinShareButton,
	FacebookIcon,
	LinkedinIcon,
} from 'react-share';
import BlueSkyIcon from '../Assets/bluesky-1.svg'

const ShareButtons = (props) => {
	const shareUrl = window.location.href;
	const buttonSize = 32;
	const fillColor = '#22294D';
	const blueskyUrl = "https://bsky.app/intent/compose?text=" + shareUrl;
	return (
		<Box
			display='flex'
			alignItems='center'
			justifyContent='center'
			className='shareButtonsWrapper'
		>
			<p
				style={{
					paddingRight: '0.6rem',
					margin: 0,
					color: 'white'

				}}
			>
				Share on:{' '}
			</p>
			<Box
				alignItems="center"
				justifyContent="center"
				sx={{
					width: "34px",
					height: "34px",
					border: 1,
					borderColor: "white",
					borderRadius: "50%",
					marginRight: "5px"
				}}
				>
				<a
					href={blueskyUrl}
					target="_blank"
					rel="noopener noreferrer"
					style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}
				>
					<img
					src={BlueSkyIcon}
					width="14px"
					height="14px"
					alt="BlueSky"
					// style={{ filter: "invert(1)" }}
					/>
				</a>
				</Box>

			<Box
			sx={{width:'34px',height:'34px', border:1,borderColor:'white', borderRadius:"50%",marginRight:'5px'}}>
			<FacebookShareButton
				url={shareUrl}
				children={
					<FacebookIcon
						bgStyle={{ fill: fillColor }}
						size={buttonSize}
						round={true}
					/>
				}
			/>
			</Box>
			<Box
			sx={{width:'34px',height:'34px', border:1,borderColor:'white', borderRadius:"50%"}}>
			<LinkedinShareButton
				url={shareUrl}
				children={
					<LinkedinIcon
						bgStyle={{ fill: fillColor }}
						size={buttonSize}
						round={true}
					/>
				}
			/>
			</Box>

		</Box>
	);
};

export default ShareButtons;
